const React = require('react');
const { createPortal } = require('react-dom');

const SSRPortal = (childElement, hostElementQuery) => {
  if (typeof document !== 'undefined') {
    return createPortal(childElement, document.querySelector(hostElementQuery));
  }

  return <></>;
};

module.exports = { SSRPortal };
